import * as Sentry from '@sentry/react';
import { useMathJaxContext } from '../providers/Provider';
import { clear } from '@testing-library/user-event/dist/types/utility';

// eslint-disable-next-line import/prefer-default-export
export const useMathJax = () => {
  const { MathJax, isError, isMathJaxLoaded, isInitialized, MathJaxErrorToast } = useMathJaxContext();

  function updateMathContent(ref, onFinish) {
    if (!ref || !ref.current) {
      return;
    }
    if (!MathJax || typeof MathJax.typesetPromise !== 'function') {
      var message = "Unknown MathJax error.";
      if (!isMathJaxLoaded) {
        message = "MathJax is not loaded.";
      }
      if (!isInitialized) {
        message = "Sentry is not initialized.";
      }
      if (isError) {
        message = "MathJax failed.";
      }
      Sentry.withScope((scope) => {
        scope.setTag('exception', 'Invalid MathJax instance.');
        Sentry.captureMessage(`MathJax unavailable: ${message}`);
      });
      MathJaxErrorToast();
      return;
    }

    MathJax.typesetPromise([ref.current])
      .then(onFinish)
      .catch((e) => {
        MathJaxErrorToast();
        Sentry.withScope((scope) => {
          scope.setTag('exception', 'Mathjax TypeError.');
          Sentry.captureException(e);
        });
      });
  }

  function clearMathContent(ref) {
    if (!ref || !ref.current || !MathJax || typeof MathJax.typesetClear !== 'function') {
      return;
    }
    try {
      MathJax.typesetClear([ref.current]);
    } catch (e) {
      console.error('Error clearing MathJax content:', { e, element: ref.current });
    }
  }

  return [MathJax, updateMathContent, clearMathContent];
};
